import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import InteractiveEducationButton from '../InteractiveEducationButton';
import { EnrollLessonButton } from '../../../userProgress/components/EnrollButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewModalAssessmentTitleContainer = ({
  displayInteractiveEducation,
  handleDisplayInteractiveEducation,
  onEnroll,
  contentId
}) => {
  const handleInteractiveEducationClick = flag => () => handleDisplayInteractiveEducation(flag);
  return /*#__PURE__*/_jsx(CardWrapper, {
    paddingBlock: "600",
    paddingInline: "800",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      gap: "400",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.preAssessment.title"
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsxs(ButtonGroup, {
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          gap: "800",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsx(InteractiveEducationButton, {
            action: "ai-smart-quiz-button-rendered",
            display: displayInteractiveEducation === 'QUIZ_ME',
            handleClick: handleInteractiveEducationClick('QUIZ_ME'),
            size: 'md',
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.interactiveEducation.quiz.quizMeTitle"
            }),
            use: 'primary'
          }), /*#__PURE__*/_jsx(EnrollLessonButton, {
            id: contentId,
            onEnroll: onEnroll,
            use: "transparent"
          })]
        })
      })]
    })
  });
};